import https from '@/apis/https.js'
import store from '@/store'

let api = {
    apiQueryConfig: ()=>{
        return https({
            method: 'post',
            url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetQueryConfig`,
            data: null
        })
    },
    apiHData: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetDataQueryETCalendarH`,
                data: args
            })
        }
        else{
            return https({
                method: 'post', 
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetDataETCalendarH`,
                data: null
            })
        }
    },
    apiHDataInsert: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/InsertETCalendarH`,
                data: args
            })
        }
        else{
            return new Promise((res, rej)=>{
                res()
            })
        }
    },
    apiHDataUpdate: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/UpdateETCalendarH`,
                data: args
            })
        }
        else{
            return new Promise((res, rej)=>{
                res()
            })
        }
    },
    apiHDataDelete: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/DeleteETCalendarH`,
                data: args
            })
        }
        else{
            return new Promise((res, rej)=>{
                res()
            })
        }
    },
    apiDData: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetDataQueryETCalendarD`,
                data: args
            })
        }
        else{
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetDataETCalendarD`,
                data: null
            })
        }
    },
    apiDDataInsert: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/InsertETCalendarD`,
                data: args
            })
        }
        else{
            return new Promise((res, rej)=>{
                res()
            })
        }
    },
    apiDDataUpdate: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/UpdateETCalendarD`,
                data: args
            })
        }
        else{
            return new Promise((res, rej)=>{
                res()
            })
        }
    },
    apiDDataDelete: (args)=>{
        if(args){
            return https({
                method: 'post',
                url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/DeleteETCalendarD`,
                data: args
            })
        }
        else{
            return new Promise((res, rej)=>{
                res()
            })
        }
    },
    apiGetNameByID: ()=>{
        return https({
            method: 'post',
            url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetNameByID`,
            data: null
        })
    },
    apiGetPrompts: ()=>{
        return https({
            method: 'post',
            url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetPrompts`,
            data: null
        })
    },
    // 開窗-品號
    apiGetINVMB: ()=>{
        return https({
            method: 'post',
            url: `https://eip2.sag.tw/SAGVueFrameApi/APSPPAUI06/GetINVMB`,
            data: null
        })
    }
}

if(store.state.webConfig.apiTest){
    api = {
        apiQueryConfig: ()=>{
            return https({
                method: 'post',
                url: `http://localhost:12345/APSPPAUI06/GetQueryConfig`,
                data: null
            })
        },
        apiHData: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/GetDataQueryETCalendarH`,
                    data: args
                })
            }
            else{
                return https({
                    method: 'post', 
                    url: `http://localhost:12345/APSPPAUI06/GetDataETCalendarH`,
                    data: null
                })
            }
        },
        apiHDataInsert: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/InsertETCalendarH`,
                    data: args
                })
            }
            else{
                return new Promise((res, rej)=>{
                    res()
                })
            }
        },
        apiHDataUpdate: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/UpdateETCalendarH`,
                    data: args
                })
            }
            else{
                return new Promise((res, rej)=>{
                    res()
                })
            }
        },
        apiHDataDelete: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/DeleteETCalendarH`,
                    data: args
                })
            }
            else{
                return new Promise((res, rej)=>{
                    res()
                })
            }
        },
        apiDData: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/GetDataQueryETCalendarD`,
                    data: args
                })
            }
            else{
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/GetDataETCalendarD`,
                    data: null
                })
            }
        },
        apiDDataInsert: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/InsertETCalendarD`,
                    data: args
                })
            }
            else{
                return new Promise((res, rej)=>{
                    res()
                })
            }
        },
        apiDDataUpdate: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/UpdateETCalendarD`,
                    data: args
                })
            }
            else{
                return new Promise((res, rej)=>{
                    res()
                })
            }
        },
        apiDDataDelete: (args)=>{
            if(args){
                return https({
                    method: 'post',
                    url: `http://localhost:12345/APSPPAUI06/DeleteETCalendarD`,
                    data: args
                })
            }
            else{
                return new Promise((res, rej)=>{
                    res()
                })
            }
        },
        apiGetNameByID: ()=>{
            return https({
                method: 'post',
                url: `http://localhost:12345/APSPPAUI06/GetNameByID`,
                data: null
            })
        },
        apiGetPrompts: ()=>{
            return https({
                method: 'post',
                url: `http://localhost:12345/APSPPAUI06/GetPrompts`,
                data: null
            })
        },
        // 開窗-品號
        apiGetINVMB: ()=>{
            return https({
                method: 'post',
                url: `http://localhost:12345/APSPPAUI06/GetINVMB`,
                data: null
            })
        }
    }
}

export default api
